import { render, staticRenderFns } from "./otherSendMsg.vue?vue&type=template&id=2e7ab560&scoped=true&"
import script from "./otherSendMsg.vue?vue&type=script&lang=js&"
export * from "./otherSendMsg.vue?vue&type=script&lang=js&"
import style0 from "./otherSendMsg.vue?vue&type=style&index=0&id=2e7ab560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ab560",
  null
  
)

export default component.exports